<template>
  <!-- Same shell as the web account area: flat page surface, one sticky bar. -->
  <div class="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-900">
    <!-- Top Bar -->
    <ServerTopBar
      :cloud-user="authStore.cloudUser"
      :is-cloud-authenticated="authStore.isCloudAuthenticated"
      @open-menu="menuOpen = true"
      @open-services="servicesOpen = true" />

    <!-- Page Content -->
    <main class="flex-1 relative z-10 pb-safe">
      <slot />
    </main>

    <!-- Menu Drawer -->
    <ServerMenuDrawer
      v-model="menuOpen"
      :cloud-user="authStore.cloudUser"
      :is-cloud-authenticated="authStore.isCloudAuthenticated"
      @sign-in="handleCloudSignIn"
      @sign-out="handleCloudSignOut"
      @open-settings="settingsOpen = true"
      @enter-touch-mode="handleEnterTouchMode" />

    <!-- Settings Modal -->
    <ServerSettingsModal v-model="settingsOpen" @enter-touch-mode="handleEnterTouchMode" />

    <!-- Services launcher (Torik Cloud portals) -->
    <ServiceLauncherModal v-model="servicesOpen" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import { useWebRTCStore } from '../stores/webrtc';
import { startCloudOAuthLogin } from '../services/cloud-oauth';
import ServerTopBar from '../components/server/ServerTopBar.vue';
import ServerMenuDrawer from '../components/server/ServerMenuDrawer.vue';
import ServerSettingsModal from '../components/server/ServerSettingsModal.vue';
import ServiceLauncherModal from '../components/server/ServiceLauncherModal.vue';

const router = useRouter();
const authStore = useAuthStore();
const webrtcStore = useWebRTCStore();
const menuOpen = ref(false);
const settingsOpen = ref(false);
const servicesOpen = ref(false);

async function handleCloudSignIn() {
  menuOpen.value = false;
  await startCloudOAuthLogin();
}

function handleCloudSignOut() {
  menuOpen.value = false;
  if (webrtcStore.connected || webrtcStore.connecting) {
    webrtcStore.disconnect();
  }
  // Signing out of the account takes every tab with it; the pinned launcher is
  // what is left (`closeTabs` → `closeAllTabsToLauncher`).
  authStore.logoutFromCloud({ closeTabs: true });
}

function handleEnterTouchMode() {
  menuOpen.value = false;
  router.push('/pair');
}
</script>
